module.exports = __webpack_public_path__ + "static/media/scrive_logo.1ef95a28.svg";